import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Station } from '../../../types/station';

// Releases older than this ship a collector that cannot pick the configuration up.
export const OBSERVE_MIN_PYSCALEO_VERSION = 'v4.67.22';
// Fill in once the release carrying automatic Observe config delivery is tagged.
export const OBSERVE_AUTO_DELIVERY_VERSION = 'v4.xx.xx';

interface CreateObserveSiteDialogProps {
  visible: boolean;
  station: Station | null;
  busy: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

export const CreateObserveSiteDialog = ({
  visible,
  station,
  busy,
  onHide,
  onConfirm,
}: CreateObserveSiteDialogProps) => {
  const footer = (
    <>
      <Button label={'Anuluj'} icon="pi pi-times" className="p-button-text" onClick={onHide} disabled={busy} />
      <Button label={'Utwórz site'} icon="pi pi-plus-circle" onClick={onConfirm} disabled={busy} />
    </>
  );

  return (
    <Dialog
      visible={visible}
      header={
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <i className="pi pi-chart-line p-mr-3" style={{ fontSize: '2rem' }} />
          {"Tworzenie site'a w Cobrick Observe"}
        </span>
      }
      modal
      className="p-fluid"
      footer={footer}
      onHide={onHide}
      breakpoints={{ '896px': '90vw' }}
      style={{ maxWidth: '640px' }}
    >
      <div className="confirmation-content">
        <Message
          severity="info"
          text={
            `Wymaga pyscaleo od ${OBSERVE_MIN_PYSCALEO_VERSION} - starsze wersje: site powstanie, ale bez ` +
            `telemetrii. Do ${OBSERVE_AUTO_DELIVERY_VERSION}: konfigurację wgrywamy ręcznie przez SSH (pozycja ` +
            `„Pobierz konfigurację"). Od ${OBSERVE_AUTO_DELIVERY_VERSION}: dojedzie sama przy synchronizacji.`
          }
          className="p-mb-3 p-d-block"
        />

        <p>
          {'Site dla '}
          <strong>{station?.name}</strong>
          {station?.installationId ? ` (${station.installationId})` : ''}
          {'. Poświadczenia trafią do AWS Secrets Manager. Site jest wspólny dla systemu - jeśli inne '}
          {'stanowisko tego samego systemu już go ma, zostanie przypisany istniejący.'}
        </p>
      </div>
    </Dialog>
  );
};
